import {request} from '@/helpers/apiClient'
import {FILE_UPLOAD_CONFIG} from '@/utils/constants/apiConfig/fileUploadConfig'

export const addMetaData = options => request(FILE_UPLOAD_CONFIG.METADATA, {data: options})
export const publishProductList = options =>
  request(FILE_UPLOAD_CONFIG.PUBLISH_PRODUCT_LIST(options?.uuid), {data: options})
